import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { promotionAPI } from '../api/promotionAPI';
import { dealsListAdapter } from '../libs/dealsAdapter';
import { useGetNearesBranch } from '../../addresses/services/getNearBranch';

export const useGetDealsList = () => {
  const { i18n } = useTranslation();
  // Филиал — тот же, что у баннеров на главной: пока он не определён по
  // адресу/геолокации/самовывозу, запрос уходит без branch_id.
  const { nearest, isBranchResolved } = useGetNearesBranch();
  const branchId = isBranchResolved ? nearest?.branch_id : undefined;
  const initData = useMemo(() => dealsListAdapter(), []);

  const { data = initData, isLoading } = useQuery({
    // Язык и филиал в ключе: подборка и тексты у каждого свои, кэш одного
    // не должен показываться в другом.
    queryKey: ['deals-list', i18n.language, branchId],
    queryFn: async () => await promotionAPI.getDealsList(branchId),
    select: data => dealsListAdapter(data.data),
  });

  return {
    ...data,
    isLoading,
  };
};
